import { combineReducers } from 'redux';
import favouritesReducer from './reducer_favourites';
import stringsReducer from './reducer_strings';
import langSwitchReducer from './reducer_lang_switch';
import autoplayReducer from './reducer_autoplay_next';
import sideNavReducer from './reducer_side_nav';
import {
  parentControlState,
  stateChangeSuccess,
  pinChangeSuccess,
  pinCheckSuccess,
  pinDisableSuccess,
} from './reducer_parent_controls';
import {
  fetchHomeCategories,
  fetchHomeCategoriesHasErrored,
  fetchHomeCategoriesIsLoading,
} from './reducer_categories_home';
import {
  advertsIsLoading,
  advertsHasErrored,
  stingSeriesIdItems,
  stingProgrammeIdItems,
  advertsDisableItems,
  stingCatIdItems,
} from './reducer_adverts';
import {
  progResumeFetch,
  progResumeIsLoading,
  progResumeHasErrored,
} from './reducer_prog_resume';
import { RESET_USER_DATA } from '../actions/types';
import loginRedriect from './reducer_login_redirect';

// MyS4C
import { reducer as formReducer } from 'redux-form';
import authReducer from './reducer_auth';
import {
  userSignUpError,
  userSignUpSuccess,
  userVerifyError,
  userVerifySuccess,
  userData,
  changeEmail,
  verifyChangeEmail,
  userUpdateSuccess,
  emailReducer,
  changePassword,
  forgottenPassword,
  mailListData,
  mailListUpdate,
  profileSet,
  profileData,
  profileUpdateSuccess,
  profileDeleteSuccess,
  profileName,
  changePasswordLoggedIn,
  profileId,
  deleteUserSuccess,
  addAddToMyList,
  removeAddToMyList,
  profileSetSuccess,
  profileIsChild,
} from './reducer_mys4c';

import { reducer as modal } from 'redux-modal';

import { globalReducer } from './globalReducers';
import {
  REDUCER_NOW_NEXT,
  REDUCER_PROG,
  REDUCER_CATCHUP_DAYS,
  REDUCER_SEARCH_RESULTS,
  REDUCER_SEARCH_KEYWORD,
  REDUCER_AZ_LETTERS,
  REDUCER_AZ_PROGRAMMES,
  REDUCER_CATEGORIES,
  REDUCER_CATEGORIES_DATA,
  REDUCER_EXTRA_FEED_HOME,
  REDUCER_EXTRA_FEED,
  REDUCER_PROMO,
  REDUCER_CATCHUP_DAY,
  REDUCER_CATCHUP_FEATURE,
  REDUCER_IMG_OVERRIDE,
  REDUCER_PODCASTS,
  REDUCER_WATCHING,
  REDUCER_MY_LIST,
  REDUCER_CHECK_EMAIL,
  REDUCER_BROADCAST_SMART_PIN,
  REDUCER_PROCESS_SMART_PIN,
  REDUCER_PROFILES,
  REDUCER_CYSILL_SEARCH,
  REDUCER_CATEGORY_CONTENT,
  REDUCER_SEARCH_MAPPING,
  REDUCER_TECH_MESSAGE,
  REDUCER_CHANNELS,
  REDUCER_BOXSETS,
  REDUCER_HOME,
  REDUCER_COMBINED_PROG_LOAD,
  REDUCER_CAT_PROGRAMME_ROWS_DATA,
  REDUCER_AVATARS,
  REDUCER_POPULAR,
  REDUCER_TRENDING,
  REDUCER_TOP_PICKS,
  REDUCER_MORE_LIKE,
  REDUCER_PROG_AVAIL
} from "../constants";

const initialStateSuccessArray = { success: [], loading: false, error: false };

/* The apps main reducers, please add reducers that you wish not to be reset when user logs out */
const mainReducers = {
  now: globalReducer(REDUCER_NOW_NEXT),
  prog: globalReducer(REDUCER_PROG),
  progPlus: globalReducer(REDUCER_COMBINED_PROG_LOAD, {
    success: false,
    loading: false,
    error: false,
  }),
  catchupDays: globalReducer(REDUCER_CATCHUP_DAYS, initialStateSuccessArray),
  searchResults: globalReducer(
    REDUCER_SEARCH_RESULTS,
    initialStateSuccessArray
  ),
  searchKeyword: globalReducer(REDUCER_SEARCH_KEYWORD, {
    success: '',
    loading: false,
    error: false,
  }),
  azLetters: globalReducer(REDUCER_AZ_LETTERS),
  azProgrammes: globalReducer(REDUCER_AZ_PROGRAMMES, initialStateSuccessArray),
  categories: globalReducer(REDUCER_CATEGORIES),
  catProgrammes: globalReducer(REDUCER_CATEGORIES_DATA),
  extraFeedHomeItems: globalReducer(REDUCER_EXTRA_FEED_HOME),
  extraFeedItems: globalReducer(REDUCER_EXTRA_FEED),
  promoFetch: globalReducer(REDUCER_PROMO),
  catchupDay: globalReducer(REDUCER_CATCHUP_DAY),
  catchUpFeatureItems: globalReducer(REDUCER_CATCHUP_FEATURE),
  fetchImgOverride: globalReducer(REDUCER_IMG_OVERRIDE),
  podcastsItems: globalReducer(REDUCER_PODCASTS),
  emailCheck: globalReducer(REDUCER_CHECK_EMAIL),
  smartPinProcess: globalReducer(REDUCER_PROCESS_SMART_PIN),
  smartPinBroadcst: globalReducer(REDUCER_BROADCAST_SMART_PIN),
  cysill: globalReducer(REDUCER_CYSILL_SEARCH),
  profilesData: globalReducer(REDUCER_PROFILES),
  searchCategoryContent: globalReducer(
    REDUCER_CATEGORY_CONTENT,
    initialStateSuccessArray
  ),
  searchMappingItems: globalReducer(REDUCER_SEARCH_MAPPING),
  techMessage: globalReducer(REDUCER_TECH_MESSAGE),
  favourites: favouritesReducer,
  fetchHomeCategories,
  fetchHomeCategoriesHasErrored,
  fetchHomeCategoriesIsLoading,
  form: formReducer,
  auth: authReducer,
  modal,
  forgottenPassword,
  advertsIsLoading,
  advertsHasErrored,
  stingSeriesIdItems,
  stingProgrammeIdItems,
  stingCatIdItems,
  advertsDisableItems,
  uiStrings: stringsReducer,
  curLang: langSwitchReducer,
  loginRedirect: loginRedriect,
  channels: globalReducer(REDUCER_CHANNELS),
  boxsets: globalReducer(REDUCER_BOXSETS),
  home: globalReducer(REDUCER_HOME),
  fetchProgAvail: globalReducer(REDUCER_PROG_AVAIL),
  catProgRows: globalReducer(REDUCER_CAT_PROGRAMME_ROWS_DATA),
  avatarItems: globalReducer(REDUCER_AVATARS),
};

/* The apps user reducers, please add reducers that you would like to be reset when user logs out */
const authReducers = {
  watchingData: globalReducer(REDUCER_WATCHING),
  list: globalReducer(REDUCER_MY_LIST),
  popular: globalReducer(REDUCER_POPULAR),
  trending: globalReducer(REDUCER_TRENDING),
  topPicks: globalReducer(REDUCER_TOP_PICKS),
  moreLike: globalReducer(REDUCER_MORE_LIKE),
  mailListData,
  mailListUpdate,
  profileSet,
  profileData,
  profileUpdateSuccess,
  profileDeleteSuccess,
  profileName,
  progResumeFetch,
  progResumeIsLoading,
  progResumeHasErrored,
  changePasswordLoggedIn,
  deleteUserSuccess,
  profileId,
  addAddToMyList,
  removeAddToMyList,
  profileSetSuccess,
  autoNext: autoplayReducer,
  sideNav: sideNavReducer,
  parentControlState,
  parentControlSateSuccess: stateChangeSuccess,
  pinChangeSuccess,
  pinDisableSuccess,
  pinCheckSuccess,
  changeEmail,
  verifyChangeEmail,
  userUpdateSuccess,
  email: emailReducer,
  changePassword,
  userSignUpError,
  userSignUpSuccess,
  userVerifyError,
  userVerifySuccess,
  userData,
  favourites: favouritesReducer,
  profileIsChild,
};

/* Pass the two reducers objects above into combineReducers */
const appReducer = combineReducers({ ...mainReducers, ...authReducers });

const rootReducer = (state, action) => {
  if (action.type === RESET_USER_DATA) {
    /* If type is equal to RESET_USER_DATA it goes ahead and resets the states, but keeps the values that are in mainReducers */
    let keepObj = {};
    if (Object.keys(mainReducers).length > 0) {
      for (let key in mainReducers) {
        keepObj[key] = state[key];
      }
    }
    state = keepObj;
  }

  /*
	appReducer passed authReducers to their reducers as undefined, so ressetting their states
	then passes mainReducers to their reducers as their current value, so they retain their values
	*/

  return appReducer(state, action);
};

export default rootReducer;
